export const ASSETS = {
  fullLogo:
    "https://customer-assets-agu9un31.emergentagent.net/job_b4cd7336-f762-47a8-b48b-63c1c2a4274c/artifacts/odgy5jdt_WhatsApp%20Image%202026-09-01%20at%2012.56.05%20PM.jpeg",
  shortLogo:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_artwork360-b2b/artifacts/g8plbjcn_short%20logo%20Artwork%20360.png",
  founderAnup:
    "https://customer-assets-agu9un31.emergentagent.net/job_b4cd7336-f762-47a8-b48b-63c1c2a4274c/artifacts/rfkr1xxn_Anup%20Website%20Photo.webp",
  founderAishwarya:
    "https://customer-assets-agu9un31.emergentagent.net/job_b4cd7336-f762-47a8-b48b-63c1c2a4274c/artifacts/04w8ckzm_Aishwarya%20Website%20Photo.webp",
  clientStran:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_artwork360-b2b/artifacts/640d757000d2f3bc_STRAN.png",
  clientImpact:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_artwork360-b2b/artifacts/dab623558b94aa93_IMPACT.png",
  clientBlvd:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_artwork360-b2b/artifacts/pb7c51dw_image.png",
  teamPhoto:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_artwork360-b2b/artifacts/yh1hlv18_0I6A9374.webp",
  heroTexture:
    "https://images.unsplash.com/photo-1715154470884-1c2be0b0129f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  apparelPrint:
    "https://images.unsplash.com/photo-1663433567177-9f94be0bff4c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  designerAtWork:
    "https://images.unsplash.com/photo-1613980790147-f4f449df0dd9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  promoMerch:
    "https://images.unsplash.com/photo-1590102426275-8d1c367070d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const CONTACT = {
  email: "contact@artwork-360.com",
  company: "Malansh Solutions Pvt Ltd",
  address: "Shop No. 8, Bldg No. 2, Samata Nagar Society, Tulsidham, Thane West 400606, India",
  hoursLine: "Our team's availability aligns with your business hours.",
};
